import { Component,Input } from '@angular/core';
import { NavParams, ModalController,PopoverController } from '@ionic/angular';

import { Utilities, DateRange } from '../../../utilities/utilities';


@Component({
  selector: 'app-range-group-selector',
  templateUrl: './range-group-selector.component.html',
  styleUrls: ['./range-group-selector.component.scss'],
})
export class RangeGroupSelectorComponent {

  @Input() groupByOptions = [
    {label: 'Daily', value: 'daily'},
    {label: 'Weekly', value: 'weekly'},
    {label: 'Monthly', value: 'monthly'}
  ];

  constructor (private popoverCtrl: PopoverController,
    private navParams: NavParams) {

    /*if (this.navParams.get('groupByOptions')) {
      this.groupByOptions = this.navParams.get('groupByOptions'); 
    }*/
  }

  public onSelect (value: string) {
    this.popoverCtrl.dismiss(value);
  }

}
